/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faRotate } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import AssetsIcon from "../../../assets/icons/asset-01.svg2";
import HelpButton from "../../HelpContent/HelpButton";
import { useGetAssetsStatsQuery } from "../../store/slices/settingsSlice";
import { formatAssetKind } from "../../Assets/AssetKind";
import { AbsoluteLoadingIndicator } from "../FullScreenLoadingIndicator";

export default function AssetsWidget() {
  const {
    data: assetsStats,
    isLoading: statsLoading,
    isFetching: statsFetching,
    refetch,
  } = useGetAssetsStatsQuery();
  const loading = statsLoading || statsFetching;

  return (
    <div className="position-relative px-2 d-flex flex-column h-100">
      <AbsoluteLoadingIndicator loading={loading} />
      <div className="d-flex p-3 pb-1 align-items-center">
        <AssetsIcon width={20} className="white opacity-50" />
        <Link className="btn p-0 text-white" to="/assets/assets">
          <h6 className="m-0 mx-2 small fw-bold">ASSETS</h6>
        </Link>
        <button
          className="btn p-0 text-white ms-2"
          onClick={() => refetch()}
          disabled={loading}
          title="Refresh assets data"
        >
          <FontAwesomeIcon
            icon={faRotate}
            className={`opacity-50 ${loading ? "spin" : ""}`}
          />
        </button>
        <HelpButton helpKey="widget-assets" iconClassName="white" />
        <FontAwesomeIcon
          icon={faGripVertical}
          className="ms-4 opacity-50 widget-header"
        />
      </div>
      <div className="">
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 opacity-50">Number of assets</span>
          <h3 className="fw-bold m-0 p-1">{assetsStats?.TotalAssets || 0}</h3>
        </div>{" "}
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1  opacity-50">Assets by type</span>
        </div>
        {assetsStats?.AssetsByKind ? (
          Object.entries(assetsStats.AssetsByKind).map(([kind, count]) => (
            <div key={kind} className="d-flex justify-content-between px-3">
              <span className="fw-bold p-1 small opacity-50">{formatAssetKind(kind)}</span>
              <h3 className="fw-bold m-0 p-1 small">{count}</h3>
            </div>
          ))
        ) : (
          <div className="d-flex justify-content-between px-3">
            <span className="fw-bold p-1 small opacity-50">No data</span>
          </div>
        )}
        {[
          {
            label: <div className="opacity-50">Number of locations</div>,
            value: `${assetsStats?.TotalLocations || 0}`,
          },
          {
            label: <div className="opacity-50">Associated contacts</div>,
            value: <div>{assetsStats?.TotalAssociatedContacts || 0}</div>,
          },
          {
            label: <div className="opacity-50">Connected assets</div>,
            value: <div>{assetsStats?.TotalParentAssets || 0}</div>,
          },
          {
            label: <div className="opacity-50">Dependant assets</div>,
            value: <div>{assetsStats?.TotalChildAssets || 0}</div>,
          },
        ].map((r, i) => (
          <React.Fragment key={i}>
            <hr className="m-1" />
            <div className="d-flex justify-content-between px-3">
              <span className="fw-bold p-1">{r.label}</span>
              <h3 className="fw-bold m-0 p-1">{r.value}</h3>
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className="flex-grow-1" />
    </div>
  );
}
